var bighouse = bighouse || {};

bighouse.main = (function () {

    function init() {
        $('html').removeClass('no-js').addClass('js');
        scrollToLink('.js-scrollTo');
        checkTouch();
    }


    function scrollToLink(selector) {

        $(selector).on('click', function (e) {
            var elem = $(this).attr('href');
            var offset = 0;
            var time = 500;
            var top = 0;

            if( elem.length > 1 && $(elem).length > 0 ){
                offset = 40;
                top = $(elem).offset().top;
            }

            $('html, body').animate({
                scrollTop: (top - parseInt(offset))
            }, time);


            e.preventDefault();
        });
    }

    function checkTouch(){
        if( is_touch_device() ){
            $('html').addClass('u-touch');
        }
    }



    function is_touch_device() {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        var mq = function(query) {
          return window.matchMedia(query).matches;
        }
      
        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
          return true;
        }
      
        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    }


    return {
        init: init,
        scrollToLink: scrollToLink
    };

})();


// Load modules here
$(document).ready(function () {

    bighouse.main.init();
    bighouse.lightbox.init();
    bighouse.mobileNav.init();
    bighouse.nav.init();
    bighouse.pageSidebar.init();

    bighouse.animate.init();
    bighouse.addressfinder.init();
    bighouse.accordion.init();
    bighouse.backToTop.init();
    bighouse.bookingPanel.init();
    bighouse.booking2.init();
    bighouse.carousel.init();
    bighouse.carouselBed.init();
    bighouse.clipboard.init();
    bighouse.compare.init();
    bighouse.gallery.init();
    bighouse.header.init();
    bighouse.hero.init();
    bighouse.lightboxTour.init();
    bighouse.locationsMenu.init();
    bighouse.map.init();
    bighouse.rangeSlider.init();
    bighouse.reviews.init();
    bighouse.search.init();
    bighouse.searchCarousel.init();
    bighouse.searchDatepicker.init();
    bighouse.searchFilters.init();
    bighouse.searchNoResults.init();
    bighouse.searchTags.init();
    bighouse.share.init();
    bighouse.textimage.init();
    bighouse.addressfinder.init();
    bighouse.sagepay.init();
    bighouse.mailchimpNewsletter.init();
});

